const pageQuery = `
    query Page($slug: String!) {
        nodeByUri(uri: $slug) {
            ... on Page {
                title
                id
                categories {
                    contentTheme
                }
                news {
                    featuredArticle {
                        ... on Post {
                            id
                            slug
                            post {
                                featuredImage {
                                    sourceUrl(size: _1920X1080)
                                    srcSet(size: _1920X1080)
                                    sizes(size: _1920X1080)
                                }
                                author {
                                    ... on CisilionAuthor {
                                        id
                                        title
                                        author {
                                            position
                                            featuredImage {
                                                sizes(size: LARGE)
                                                sourceUrl(size: LARGE)
                                                srcSet(size: LARGE)
                                            }
                                            company
                                        }
                                    }
                                }
                            }
                            title
                            date
                        }
                    }
                }
                seo {
                    title
                    metaDesc
                    metaKeywords
                    metaRobotsNofollow
                    metaRobotsNoindex
                    canonical
                    opengraphDescription
                    opengraphTitle
                    twitterTitle
                    twitterDescription
                    twitterImage {
                        sourceUrl(size: LARGE)
                    }
                    opengraphImage {
                        sourceUrl(size: LARGE)
                    }
                }
                pageOptions {
                    headerStyle
                }
            }
        }
    }
`;

export default pageQuery;
